var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',[_c('customer-tracking-table',{attrs:{"consultant-id":_vm.consultantId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }